module.exports = __webpack_public_path__ + "static/media/7de677e6-7a2e-490f-9c7f-b6cc52d2933a.e6833613.jpg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/chicago-council-headshots/dist/img/headshots/7de677e6-7a2e-490f-9c7f-b6cc52d2933a.jpg
// module id = 832
// module chunks = 0